export default __webpack_public_path__ + "static/media/Pc7.f2631798.jpg";